<template>
  <svg
    :width="size"
    :height="size"
    :viewBox="'0 0' + ' ' + size + ' ' + size"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <filter id="filter-1">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 0.298039 0 0 0 0 0.298039 0 0 0 0 0.298039 0 0 0 1.000000 0"
        ></feColorMatrix>
      </filter>
    </defs>
    <g id="DISEÑO-HF-INVISION" stroke="none" stroke-width="1" :fill="color" fill-rule="evenodd">
      <g id="chevron-down" transform="translate(-56.000000, -313.000000)" filter="url(#filter-1)">
        <g
          transform="translate(64.000000, 321.000000) scale(-1, 1) rotate(90.000000) translate(-64.000000, -321.000000) translate(56.000000, 313.000000)"
        >
          <path
            d="M8,9.05719096 L4.47140452,5.52859548 C4.21105499,5.26824595 3.78894501,5.26824595 3.52859548,5.52859548 C3.26824595,5.78894501 3.26824595,6.21105499 3.52859548,6.47140452 L7.52859548,10.4714045 C7.78894501,10.731754 8.21105499,10.731754 8.47140452,10.4714045 L12.4714045,6.47140452 C12.731754,6.21105499 12.731754,5.78894501 12.4714045,5.52859548 C12.211055,5.26824595 11.788945,5.26824595 11.5285955,5.52859548 L8,9.05719096 Z"
            id="Shape"
            fill="#000000"
            fill-rule="nonzero"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-add",
  components: {},
})
export class IconGreaterThan extends Vue {
  @Prop({ default: 26 }) size!: number;
  @Prop({ default: "#ffffff" }) color!: string;

  constructor() {
    super();
  }
}
export default IconGreaterThan;
</script>
